<template>
  <h3>Base information about Wininfin project</h3>
  <p>This page is currently under reconstruction</p>
  <br><br>
</template>

<script>
</script>